import FormGatewayInterface from "../../domain/Form/FormGatewayInterface";
import FormsInterface from "../../domain/Form/FormsInterface";
import storage from "../../presentation/util/storage";

export default class GetFormsUseCase
{
  public formGatewayInterface;

  constructor(formGatewayInterface: FormGatewayInterface) {
    this.formGatewayInterface = formGatewayInterface;
  }

  async execute(): Promise<FormsInterface[]> {
    const cachedForms = storage.getForms()
    if (cachedForms.length > 0) {
      return cachedForms
    }

    const forms = await this.formGatewayInterface.getForms()
    return forms ?? []
  }
}
